<template>
    <div v-loading="loader" class="catalog">
        <div class='d-flex mb-2 justify-content-end align-items-end'>
            <a class="btn btn-outline-primary " href="/helper-files/available-product-types.xlsx">
                Types de produits
            </a>
        </div>
        <catalog-filters ref="filtersComponent" :selected="multipleSelection" :view="view"
                         @productsUpdated="updateProducts" @update-filters="onUpdateFilters"></catalog-filters>
        <div class="product-list">

            <div class="pagination">
                <div class="page-subtitle">{{ total_item }} produits</div>
                <el-button label="Pertinence" size="small" style="margin-left: 30px;" @click="sortByScore">Trier par
                    pertinence
                </el-button>
                <el-pagination ref="pagination" :current-page="params.page"
                               :page-size="params.limit" :page-sizes="page_sizes" :pager-count="11"
                               :total="total_item" layout="sizes, prev, pager, next"
                               @current-change="page => paginate(page, 'top')"
                               @size-change="handleSizeChange"></el-pagination>
            </div>
            <el-table ref="multipleTable" v-loading="loading" :cell-class-name="cellClassName"
                      :data="products" :row-class-name="tableRowClassName" stripe
                      style="width: 100%" @selection-change="handleSelectionChange" @sort-change="changeSort">
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column label="Activé/Stock" prop="activated" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <div>
                            <span>Stock PIM : <span v-html='booleanValue(scope.row.has_stock)'></span></span><br>
                            <span>Stock SP : <span v-html='booleanValue(scope.row.presta_stock)'></span></span><br>
                            <span>Actif site : <span v-html='booleanValue(scope.row.presta_activated)'></span></span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Pim Id" prop="pim_id" sortable="custom" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.id }}
                    </template>
                </el-table-column>
                <el-table-column prop="visuel" width="275">
                    <template slot-scope="scope">
                        <el-badge :value="scope.row.images.length" class="item">
                            <a class="mb-3" href="#" @click.prevent="openGalery(scope.row)">
                                <span v-if="scope.row.image"
                                      :style="{backgroundImage: 'url(\'/ic/listing/'+scope.row.image.path+'\')'}"
                                      class="product-image-listing avatar"></span>
                                <span v-else-if="scope.row.images.length"
                                      :style="{backgroundImage: 'url(\'/ic/listing/'+scope.row.images[0].path+'\')'}"
                                      class="product-image-listing avatar"></span>
                                <span v-else class="product-image-listing avatar"></span>
                            </a>
                        </el-badge>
                    </template>
                </el-table-column>
                <el-table-column label="Shop Id" prop="shop_id" sortable="custom" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.shop_id }}
                        <span v-if="scope.row.sync_put_status">&nbsp;
                            <el-badge v-if="scope.row.sync_put_status=='processed'" class="item" type="success"
                                      value=" ">&nbsp;</el-badge>
                            <el-badge v-else-if="scope.row.sync_put_status=='processing'" class="item" type="warning"
                                      value=" ">&nbsp;</el-badge>
                            <el-badge v-else-if="scope.row.sync_put_status=='failed'" class="item" type="danger"
                                      value=" ">&nbsp;</el-badge>
                        </span>
                        <span v-if="scope.row.shop_id">&nbsp;
                            <a :href="scope.row.shop_url" target="_blank"><i class="fe fe-globe"></i></a>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Titre" prop="name" sortable="custom" width="200">
                    <template slot-scope="scope">

                        <span v-if="scope.row.feature_type">[{{ scope.row.feature_type }}] </span>{{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Ref fournisseur" prop="external_ref" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                        <span v-if="scope.row.base_ref">
                            <br>
                            ({{ scope.row.base_ref }}<template
                            v-if="scope.row.color_code"> / {{ scope.row.color_code }}</template>)
                        </span>
                        <span v-if="scope.row.additional_reference">
                            <br>
                            <span class="text-xs" title="référence additionnel">({{ scope.row.additional_reference
                                }})</span>
                        </span>
                        <template v-if="scope.row.referencement_speedway">
                            <div>
                                <small class="text-xs">[{{ scope.row.referencement_speedway }}]</small>
                            </div>
                        </template>

                    </template>
                </el-table-column>
                <el-table-column label="Prix public Fournisseur" prop="mf_price_public" sortable="custom">
                    <template slot-scope="scope">
                        <p class='m-0'>{{ scope.row.mf_price_public }} ht</p>
                        <p class='m-0 font-weight-bold'>{{ ((scope.row.mf_price_public || 0) * 1.2).toFixed(2) }}
                            ttc</p>
                        <p v-if="scope.row.new_price" class='m-0 text-orange'>{{ scope.row.new_price }} ttc
                            <small>(PO)</small>
                        </p>
                    </template>
                </el-table-column>
                <el-table-column label="Marque" prop="brand_id" sortable="custom">
                    <template slot-scope="scope">
                        <a v-if="scope.row.brand" href="#" @click.prevent="filterInTab('brand_id', scope.row.brand.id)">{{ scope.row.brand.name
                            }}</a>
                    </template>
                </el-table-column>
                <el-table-column label="Catégorie" prop="category_id" sortable="custom" width="120">
                    <template slot-scope="scope">
                        <a v-if="scope.row.category" href="#"
                           @click.prevent="filterInTab('category_id', scope.row.categories)">{{ scope.row.category.name
                            }}</a>
                        <template v-if="scope.row.secondaryCat">
                            / <span>{{ scope.row.secondaryCat.name }}</span>
                        </template>

                    </template>
                </el-table-column>
                <el-table-column label="Variations" prop="variationsCount" sortable="custom" width="90">
                    <template slot-scope="scope">
                        <a :title="scope.row.variationsIds" href="#" @click.prevent="openVariations(scope.row)">
                            <span v-if="scope.row.variationsCount">
                                <el-badge :value="scope.row.variationsCount" class="item">
                                    O
                                </el-badge>
                            </span>
                            <span v-else>N</span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column label="Catalogue" sortable="custom" width="150">
                    <template slot-scope="scope">
                        {{ scope.row.catalog }}
                    </template>
                </el-table-column>
                <el-table-column label="Commentaire" sortable="custom" width="230">
                    <template slot-scope="scope">
                        <div class="comment-input nl2br">
                            <template v-if="!scope.row.commentActive && scope.row.comment">
                                <el-tooltip placement="top">
                                    <div slot="content" class="nl2br" v-html="scope.row.comment"></div>
                                    <span @click="scope.row.commentActive = true"
                                          v-html="truncateString(scope.row.comment, 100)"></span>
                                </el-tooltip>
                            </template>
                            <template v-if="!scope.row.commentActive && !scope.row.comment">
                                <a href="#" @click.prevent="scope.row.commentActive = true">
                                    <i class="fe fe-edit"></i>
                                </a>
                            </template>
                            <template v-if="scope.row.commentActive">
                                <el-input v-model="scope.row.comment" :rows="2"
                                          placeholder="commentaire" type="textarea"
                                          @change="() => saveComment(scope.row)"></el-input>
                                <a href="#" @click.prevent="saveComment(scope.row)">
                                    <i class="fe fe-save"></i>
                                </a>
                            </template>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="Actions" prop="syncronized_at" sortable="custom">
                    <template slot-scope="scope">
                        <a v-if="user.can('edit product')" :title="scope.row.id" class="icon"
                           @click="openModalEdit(scope.row)">
                            <i class="fe fe-edit"></i>
                        </a>
                        <a v-if="user.can('preview product')" class="icon" @click="openModalDifference(scope.row)">
                            <i class="fe fe-eye"></i>
                        </a>
                        <a v-if="user.can('remove product') && !params.deleted" class="icon"
                           @click="removeFromPim(scope.row)">
                            <i class="fe fe-trash"></i>
                        </a>
                        <a class="icon" title="Ne pas faire" @click.prevent="toggleDoNotDo(scope.row)">
                            <i :class="{'text-danger': scope.row.do_not_do}" class="fe fe-slash"></i>
                        </a>
                        <span v-if="scope.row.syncronized_at_human">
                            <br><small><i class="fe fe-watch"></i> {{ scope.row.syncronized_at_human }}</small>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination :current-page="params.page" :page-size="params.limit" :page-sizes="page_sizes"
                               :pager-count="11" :total="total_item"
                               layout="sizes, prev, pager, next" @current-change="page => paginate(page, 'bottom')"
                               @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </div>

        <el-dialog :close-on-click-modal="false" :title="'Edition produit #' + modal.product.shop_id"
                   :visible.sync="modal.display" top="1vh" width="90%" @closed="unlock(modal.product.id)">
            <catalog-edit :fetch="true" :product.sync="modal.product" :products-id="productsId" @edit-next="editNext"
                          @update-product="onUpdateProduct" @delete-product="onDeleteProduct"></catalog-edit>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeModalEdit(modal.product.id)">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog v-loading="modalGalery.loader" :title="'Ajout d\'image pour '+modalGalery.product.name"
                   :visible.sync="modalGalery.display" top="1vh" width="90%">
            <gallery-selector ref="galerySelector" v-model="modalGalery.selected" :product="modalGalery.product"
                              selectable @associated="associatedImages"></gallery-selector>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modalGalery.display = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-press-escape="false" :visible.sync="modalVariations.display" bottom="2vh"
                   title="Variations de produit" top="2vh" width="95%" @closed="modalVariationClosed">
            <product-variations :product="modalVariations.product" @added="variationAdded"
                                @removed="variationRemoved"></product-variations>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeVariations">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="lightbox.display" append-to-body class="lightbox-galery" fullscreen
                   @closed="cleanLigtbox">
            <div slog="title">
                <h4>{{ lightbox.image.filename }}</h4>
                <span v-for="(tag, indexTag) in lightbox.image.tags" :key="indexTag" class="badge badge-secondary mx-1">{{ tag.name
                    }}</span>
            </div>
            <div v-if="lightbox.image.path" v-loading="lightbox.loader" class="lightox-galery-ctn my-3">
                <img :alt="lightbox.image.filename" :src=" '/ic/original/' + lightbox.image.path"
                     @load="lightbox.loader = false">
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="lightbox.display = false">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="modalDifference.display" bottom="2vh"
                   title="Différence données Speedway / Fournisseur"
                   top="2vh" width="95%">
            <product-difference :product="modalDifference.product"
                                style="height:77vh;overflow-x: auto;"></product-difference>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="user.can('sync product')" plain type="info"
                           @click="sync('pull', modalDifference.product)">Utiliser les informations de Prestashop</el-button>
                <el-button v-if="user.can('sync product')" plain type="warning"
                           @click="sync('put', modalDifference.product)">Utiliser les informations du PIM</el-button>
                <el-button @click="closeModalDifference">Fermer</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="modalRemove.display" title="Supprimer du Pim" width="30%">
            <span>Êtes-vous sûr de le supprimer uniquement du PIM  ?</span>

            <el-alert :closable="false" title="Attention" type="warning">
                <el-checkbox v-model="modalRemove.removePrestashop">Supprimer sur le Prestashop ?</el-checkbox>
                <el-checkbox v-if="modalRemove.removePrestashop" v-model="modalRemove.forceRemovePrestashop">Supprimer
                    même si activer ?
                </el-checkbox>
            </el-alert>

            <span slot="footer" class="dialog-footer">
                <el-button @click="modalRemoveClose">Annuler</el-button>
                <el-button type="primary" @click="modalRemoveConfirm">Confirmer</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import queryString from 'query-string';
import { EventBus } from '../../event-bus';
import Product from '../../models/Product';


export default {
    data() {
        return {
            multipleSelection: [],
            page_sizes: [10, 20, 30, 40, 50, 100, 200],
            params: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            defaultParams: {
                page: 1,
                orderBy: 'id',
                order: 'ASC',
                limit: 10
            },
            filters: {},
            loading: false,
            modal: {
                display: false,
                product: {}
            },
            modalGalery: {
                display: false,
                product: {},
                selected: [],
                loader: false
            },
            modalVariations: {
                display: false,
                product: {}
            },
            modalDifference: {
                display: false,
                product: {}
            },
            lightbox: {
                display: false,
                image: {},
                loader: true
            },
            modalRemove: {
                display: false,
                product: {},
                removePrestashop: false,
                forceRemovePrestashop: false
            }
        };
    },
    props: {
        view: {
            default: 'normal'
        }
    },
    computed: {
        total_item() {
            return this.$store.getters['products/totalItems'];
        },
        products() {
            return this.$store.getters['products/items'];
        },
        currentUrl() {
            return (
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname
            );
        },
        loader: {
            get() {
                return this.$store.getters['products/loader'];
            },
            set(value) {
                this.$store.dispatch('products/setLoader', value);
            }
        },
        appEnv() {
            return this.$store.getters['app/env'];
        },
        productsId() {
            return this.$store.getters['products/items'].map(v => v.id);
        },
        user() {
            return this.$store.getters['app/user'];
        }
    },

    created() {

    },

    mounted() {
        if (window.location.search) {
            var params = queryString.parse(window.location.search);
            for (let key in params) {
                switch (key) {
                    case 'page':
                    case 'limit':
                        params[key] = parseInt(params[key]);
                        break;
                    case 'brand_id':
                    case 'manufacturer_id':
                    case 'category_id':
                    case 'category_exclude_id':
                    case 'features_exclude':
                    case 'productType':
                    case 'sizes':
                        if (typeof params[key] == 'object') {
                            var value = Object.values(params[key]).map(v => v.split(','));
                        } else if (typeof params[key] == 'Array') {
                            var value = params[key].map(v => v.split(','));
                        } else {
                            if (params[key].includes(',')) {
                                var value = [params[key].split(',')];
                            } else {
                                var value = [parseInt(params[key])];
                            }
                        }
                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                    case 'features':
                        var features = params[key];

                        if (features) {
                            if (typeof features == 'string') {
                                features = [features];
                            }
                            features = features.map(v => v.split(',').map(v => parseInt(v)));
                        }

                        this.$refs.filtersComponent.setFilter(
                            key,
                            features,
                            true
                        );
                        break;
                    case 'mf_prefixe':
                    case 'external_refs':
                    case 'base_refs':
                        this.$refs.filtersComponent.setFilter(
                            key,
                            params[key],
                            true
                        );
                        break;
                    case 'shop_ids':
                        let shop_ids = params[key];
                        if (typeof shop_ids == 'string') {
                            shop_ids = shop_ids.split(/\r?\n/);
                        }
                        shop_ids = shop_ids.map(v => parseInt(v));
                        shop_ids = shop_ids.join('\n');
                        this.$refs.filtersComponent.setFilter(
                            key,
                            shop_ids,
                            true
                        );
                        break;
                    case 'created_at':
                        var created_at = params[key];
                        this.$refs.filtersComponent.setFilter(
                            key,
                            created_at,
                            true
                        );
                        break;
                    case 'q':
                        this.$store.dispatch('app/setQ', params[key]);
                        break;
                    default:
                        if (params[key] == 'false') {
                            value = false;
                        } else if (params[key] == 'true') {
                            value = true;
                        } else if (typeof params[key] == 'string' && params[key].match(/[0-9]+/)) {
                            value = parseInt(params[key]);
                        } else if (typeof params[key] == 'string') {
                            value = null;
                        } else {
                            value = params[key];
                        }
                        this.$refs.filtersComponent.setFilter(key, value, true);
                        break;
                }
            }
            this.params = Object.assign({}, this.params, params);
        }
        this.fetch();

        EventBus.$on('products.list.refresh', () => {
            this.fetch();
        });
        EventBus.$on('products.list.edit', (product) => {
            this.openModalEdit(product);
        });
    },

    methods: {
        async saveComment(product) {
            let response = await axios.post('/products/' + product.id, {
                data: product,
                mode: 'comment'
            });
            product.commentActive = false;
            this.updateProductInList(product.id, response.data.data);
        },
        async toggleDoNotDo(product) {
            product.do_not_do = !product.do_not_do;
            let response = await axios.post('/products/' + product.id, {
                data: product,
                mode: 'toggleDoNotDo'
            });
            this.updateProductInList(product.id, response.data.data);
        },
        removeFromPim(product) {
            this.modalRemove.product = product;
            this.modalRemove.display = true;
            this.modalRemove.removePrestashop = false;
        },
        modalRemoveClose() {
            this.modalRemove = {
                display: false,
                product: {},
                removePrestashop: false
            };
        },
        modalRemoveConfirm() {
            axios.delete('/products/' + this.modalRemove.product.id, {
                params: {
                    removePrestashop: this.modalRemove.removePrestashop,
                    forceRemovePrestashop: this.modalRemove.forceRemovePrestashop
                }
            }).then((r) => {
                this.fetch();
                this.modalRemoveClose();
            });
        },
        editNext(productId) {
            this.openModalEdit({ id: productId });
        },
        setUrlParams() {
            var newUrl = this.currentUrl + '?' + queryString.stringify(this.params);
            window.history.pushState({ path: newUrl }, '', newUrl);
        },
        tableRowClassName({ row, rowIndex }) {
            var className = 'manufacturer-' + row.manufacturer_slug;
            if (row.is_stock_hybrid !== null) {
                className = className + ' hybrid';
            }
            if (row.end_of_life) {
                if (row.has_stock) {
                    className = className + ' end-of-life';
                } else {
                    className = className + ' very-end-of-life';
                }
            }
            if (row.do_not_do) {
                className = className + ' do-not-do';
            }
            return className;
        },

        cellClassName({ row, column, rowIndex, columnIndex }) {
            var className = '';
            if (column.label == 'Commentaire' && row.commentActive == true) {
                className = className + ' opacity-100';
            }
            return className;
        },

        handleSelectionChange(val) {
            this.$store.dispatch('products/setApplyToAllResults', false);
            this.multipleSelection = val;
        },

        cleanTypeParams(params) {
            for (let i in params) {
                if (params[i] == 'false') {
                    params[i] = false;
                } else if (params[i] == 'true') {
                    params[i] = true;
                }

                /** @see https://gitlab.divioseo.fr/speedway/pim/-/issues/909 */
                if (i === 'features' && typeof params[i] === 'string') {
                    params[i] = [params[i]];
                }
            }
            return params;
        },

        fetch(params) {
            if (!params) {
                params = {};
            }
            if (this.view == 'duplicate') {
                this.params.duplicate = true;
            }
            this.params = this.cleanTypeParams({ ...params, ...this.params });
            this.loading = true;
            this.setUrlParams();
            if (this.view == 'duplicate') {
                return this.$store.dispatch('products/fetchDuplicate', this.params).then(() => {
                    this.loading = false;
                });
            } else {
                return this.$store.dispatch('products/fetch', this.params).then(() => {
                    this.loading = false;
                });
            }

        },

        updateProductInList(id, data) {
            this.$store.dispatch('products/updateInList', { id, data });
        },

        deleteProductInList(id) {
            this.$store.dispatch('products/removeInList', id);
        },

        goToPage(p) {
            this.params.page = p;
            this.fetch();
        },

        changeSort(s) {
            this.params.orderBy = s.prop;
            this.params.order = s.order == 'ascending' ? 'asc' : 'desc';

            this.fetch();
        },

        sortByScore() {
            this.params.orderBy = '_score';
            this.params.order = 'desc';

            this.fetch();
        },

        removeAllFiltersToParams(params) {
            var newParams = {};
            for (let k in this.defaultParams) {
                newParams[k] = params[k];
            }
            return newParams;
        },

        onUpdateFilters(filters) {
            this.params.page = 1;
            this.params = this.removeAllFiltersToParams(this.params);
            this.params = { ...this.params, ...filters };
            if (!Object.values(filters).length) {
                this.params = Object.assign({}, this.defaultParams);
                setTimeout(() => {
                    window.history.pushState(
                        { path: this.currentUrl },
                        '',
                        this.currentUrl
                    );
                }, 100);
            }
            this.fetch();
        },

        handleSizeChange(val) {
            this.params.limit = val;
            this.fetch();
        },

        openModalEdit(product) {
            axios.post('products/' + product.id + '/lock').then((r) => {
                if (r.data.data === false) {
                    this.$notify({
                        title: 'Attention',
                        message: 'Ce produit est déjà en cours d\'édition par un autre utilisateur.',
                        type: 'warning'
                    });
                } else {
                    axios.get('products/' + product.id).then((r) => {
                        this.modal.product = new Product(r.data.data);
                        this.modal.display = true;
                        this.$store.dispatch('products/updateInList', {
                            id: product.id,
                            data: r.data.data
                        });
                    });
                }
            });
        },
        unlock(id) {
            axios.post('products/' + id + '/unlock').then((r) => {
            });
        },

        closeModalEdit(id) {
            this.modal.display = false;
        },

        openGalery(product) {
            this.modalGalery.display = true;
            this.modalGalery.product = product.clone();
            this.modalGalery.selected = [];
            if (this.$refs.galerySelector) this.$refs.galerySelector.refresh();
        },

        associatedImages({ product, variation }) {
            this.updateProductInList(product.id, product);
            this.modalGalery.product = product;
        },

        onUpdateProduct(data) {
            let product = data.product;
            this.updateProductInList(product.id, product);
            this.$nextTick(function() {
                EventBus.$emit('checkUseNewDesc');
            });
            //this.$refs.filtersComponent.validFilters();
            if (!data.rest) {
                this.closeModalEdit(product.id);
            }
        },

        updateProducts(products) {
            //this.$refs.multipleTable.clearSelection();
            products.forEach(product => {
                this.updateProductInList(product.id, product);
            });
        },

        paginate(page, paginator) {
            this.params.page = page;
            this.loader = true;
            this.fetch()
                .then(r => {
                    if (paginator == 'bottom') {
                        var element = document.querySelector(
                            '.catalog .product-list'
                        );
                        element.scrollIntoView();
                    }
                })
                .catch(() => {
                })
                .then(() => {
                    this.loader = false;
                });
        },

        onDeleteProduct(id) {
            this.deleteProductInList(id);
            this.closeModalEdit(id);
        },

        filterInTab(name, value) {
            this.$refs.filtersComponent.setFilter(name, value);
        },

        openVariations(product) {
            this.modalVariations.product = product.clone();
            this.modalVariations.display = true;
        },

        closeVariations() {
            this.modalVariations.product = {};
            this.modalVariations.display = false;
        },

        openModalDifference(product) {
            this.modalDifference.display = true;
            this.modalDifference.product = product.clone();
        },

        closeModalDifference() {
            this.modalDifference.display = false;
        },

        modalVariationClosed() {
            EventBus.$emit('modal.variations-product.closed');
        },
        variationAdded({ variation, productId }) {
            var finded = this.products.find(v => v.id == productId);
            if (finded) {
                finded.variationsCount += 1;
            }
        },
        variationRemoved({ variation, productId }) {
            var finded = this.products.find(v => v.id == productId);
            if (finded) {
                finded.variationsCount -= 1;
            }
        },

        openLightbox(image) {
            this.lightbox.loader = true;
            this.lightbox.image = {};
            this.$nextTick(function() {
                this.lightbox.image = image;
                this.lightbox.display = true;
            });
        },
        cleanLigtbox() {
            this.lightbox = {
                display: false,
                image: {},
                loader: true
            };
        },
        sync(direction, product) {
            this.$confirm('Êtes-vous sûr ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    axios.post('/products/' + product.id + '/sync', { direction }).then((r) => {
                    });
                }).catch(() => {

            });

        },
        truncateString(string, size) {
            var truncated = string;
            if (truncated.length > size) {
                truncated = truncated.substring(0, size) + ' ...';
            }
            return truncated;
        },
        booleanValue(value) {
            if (value) {
                return '<strong class="text-success">O</strong>';
            } else {
                return '<strong class="text-danger">N</strong>';
            }
        }
    }
};
</script>
<style lang="scss">
.catalog {
    .pagination {
        margin: 25px 0;

        .el-pagination {
            margin: 0 auto;
        }
    }

    .manufacturer-speedway {
        background-color: #b7ffdb47;

        &.hybrid {
            background-color: #e1b7ffe6;
        }
    }

    .very-end-of-life {
        background-color: #cc4747e6;
        color: #FFF;
    }

    .end-of-life {
        background-color: #ec8c4be6;
        color: #FFF;
    }

    .do-not-do td {
        opacity: 0.3;
    }

    .opacity-100 {
        opacity: 1 !important;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.very-end-of-life td {
        background-color: #cc5f5fe6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.end-of-life td {
        background-color: #ec9b65e6;
        color: #FFF;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped.manufacturer-speedway td {
        background-color: #b7ffdb47;
    }

}

.lightbox-galery {
    .el-dialog__body {
        height: 89vh;
        text-align: center;

        .lightox-galery-ctn {
            height: 77vh;
        }

        img {
            height: 100%;
            object-fit: contain;
        }
    }
}

.el-table__row {
    .el-badge__content.is-fixed {
        top: 10px;
        line-height: 14px;
    }
}

.comment-input {
    font-size: 12px;
}


</style>
